import qs from 'qs';
import _ from 'lodash';

const simpleStringCompare = (a: unknown, b: unknown) => _.toString(a).localeCompare(_.toString(b));

export const stringifyUrlParams = (params: object) =>
  qs.stringify(params, {
    arrayFormat: 'comma',
    skipNulls: true,
    encode: false,
    sort: simpleStringCompare,
  });
